import React from 'react'
import Link from 'next/link'

// components
import ImageWithFoster from 'components/ImageWithFoster'

// resources
import PreviewImage from 'assets/images/studio-preview-image-user.png'

// styles
import styles from './index.module.scss'

const CollectionSpotCardMobile = ({ data }) => {
  const storeImage = data?.creatorStoreUrl?.length > 0 ? data.creatorStoreUrl : PreviewImage.src
  const username = data?.creatorUsername || data?.username || '@username'
  const storeName = data?.storeName || data?.name || 'Store Name'

  return (
    <div className={`${styles.borderContainer} dark:bg-[transparent]`}>
      <div className={styles.container}>
        <div className="w-full h-full flex flex-col justify-between px-[16px] pt-[16px] pb-[22px]">
          <div>
            <div className="w-full flex gap-[16px]">
              <div className={styles.userImage}>
                <ImageWithFoster src={storeImage} className="w-full h-full rounded-[50px] overflow-hidden" />
              </div>
              <div>
                <div className={styles.userName}>{username}</div>
                <div className={styles.collectionName}>{storeName.toUpperCase()}</div>
              </div>
            </div>
            <div className="mt-[30px]">
              <div className={styles.description}>{data?.description}</div>
            </div>
          </div>
          <Link href={data?.targetUrl} passHref>
            <a>
              <div className={styles.viewCollection}>View Collection</div>
            </a>
          </Link>
        </div>
        <div className={styles.imageStack}>
          <div
            className={`${styles.imageLayer1} w-[90px] h-[118px] sm:w-[127px] sm:h-[166px] rounded-[8px] overflow-hidden`}
          >
            <ImageWithFoster src={data.items[0].itemUrl} className="w-full h-full object-cover" />
          </div>
          {data.items.length > 1 && (
            <div
              className={`${styles.imageLayer2} w-[80px] h-[104px] sm:w-[112px] sm:h-[147px] rounded-[8px] overflow-hidden`}
            >
              <ImageWithFoster src={data.items[1].itemUrl} className={`w-full h-full object-cover`} />
            </div>
          )}
          {data.items.length > 2 && (
            <div
              className={`${styles.imageLayer3} w-[72px] h-[94px] sm:w-[100px] sm:h-[133px] rounded-[8px] overflow-hidden`}
            >
              <ImageWithFoster src={data.items[2].itemUrl} className={`w-full h-full object-cover`} />
              https://devfoster.netlify.app/collection/CFNEgV6Vt7VXEJ4KE9PHb3ZBojoNQAr5uYF1cjCAzTx3
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default CollectionSpotCardMobile
